import { CATEGORIES } from "../config";

export const CategoryBadge = ({ category, size = "md" }) => {
  const c = CATEGORIES[category];
  if (!c) return null;
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`category-badge category-badge-${size}`}
      style={{ color: c.color, borderColor: `${c.color}55`, background: `${c.color}14` }}
    >
      {c.label}
    </span>
  );
};

export default CategoryBadge;
